export default "__VITE_ASSET__BfsrK6xj__"